
import React from 'react'
import { translate } from 'react-i18next'
import { AppStore, UIStore } from '../../../../stores'
import { Button } from '../../../'
import { capitalize } from '../../../../utils'

/**
 *
 */
const NoLinkedProviderAccountAlert = ({ t, ...props }) => <div className="empty-cart-alert">
  <div className="container">
    <div className="row">
      <p className="p light white s12">No dispones de una cuenta vinculada en { capitalize(AppStore.providername) } para enviar tu carrito.</p>
    </div>
    <div className="row">
      <p className="p regular white s14">Vincular cuenta para { capitalize(AppStore.providername) }</p>
      <ul>
        <li><Button placeholder="Cancelar" type="flat" color="dark-white" onClick={ props.onCancel } /></li>
        <li><Button placeholder="Vincular" type="flat" color="blue" onClick={ props.onConfirm } /></li>
      </ul>
    </div>
  </div>
</div>

export default translate(['common'], { wait: false })(NoLinkedProviderAccountAlert)
